import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import dateISO from 'src/filters/dateISO';

const query = gql`
query Report($dateFrom: String!, $dateTo: String!, $page: Int, $pageSize: Int){
  operatorsUtilizationReport(dateFrom: $dateFrom, dateTo: $dateTo, page: $page, pageSize: $pageSize) {
    absenceReasons
    operators {
       operatorId
       operatorName
       averageStatistic {
          loggedDuration
          readyDuration
          activeDuration
          idleDuration
          notReadyActiveDuration
          notReadyDuration
          absenceReasonDurations
          occupancy
       }
       statisticByDays {
          date
          loggedDuration
          readyDuration
          activeDuration
          idleDuration
          notReadyActiveDuration
          notReadyDuration
          absenceReasonDurations
          occupancy
       }
    }
    totalCount
    pageSize
  }
}`;

function getEmploymentReport({
  dateFrom, dateTo, page, pageSize,
}) {
  return apollo.client.query({
    variables: {
      dateFrom: dateISO(dateFrom),
      dateTo: dateISO(dateTo),
      page,
      pageSize,
    },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.operatorsUtilizationReport);
}

export default getEmploymentReport;
